module.exports = __webpack_public_path__ + "static/img/A61801_1.1616e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61801_1.png
// module id = oZFE
// module chunks = 1